import React from 'react';
import { WrappedFieldProps } from 'redux-form';

interface IOption {
  id: string;
  text: string;
  value: string;
}

interface IFormCheckboxProps {
  error?: string;
  options: IOption[];
  activateError?: boolean;
}

export default function FormCheckbox(
  props: WrappedFieldProps & IFormCheckboxProps,
) {
  const {
    error,
    input,
    options,
    activateError
  } = props;

  return (
    <div>
      <div className={"custom-radio-box" + (activateError ? " invalid-form-input" : "")}>
        {options.map((option: IOption) => (
          <label
            key={option.id}
            htmlFor={option.id}
            className="custom-check custom-check__radio d-flex align-items-center align-content-center"
          >
            <div className="custom-check--container">
              <input
                {...input}
                id={option.id}
                type="radio"
                value={option.value}
              />
              <div className="custom-check--bg d-flex justify-content-center align-items-center align-content-center" />
              <i />
            </div>
            <span>{option.text}</span>
          </label>
        ))}
      </div>
      {activateError && <small className="invalid m-0 mt-16 lh-1">{error}</small>}
    </div>
  );
}
